"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunityViewsByProfileDto = instanceOfOrientationOpportunityViewsByProfileDto;
exports.OrientationOpportunityViewsByProfileDtoFromJSON = OrientationOpportunityViewsByProfileDtoFromJSON;
exports.OrientationOpportunityViewsByProfileDtoFromJSONTyped = OrientationOpportunityViewsByProfileDtoFromJSONTyped;
exports.OrientationOpportunityViewsByProfileDtoToJSON = OrientationOpportunityViewsByProfileDtoToJSON;
exports.OrientationOpportunityViewsByProfileDtoToJSONTyped = OrientationOpportunityViewsByProfileDtoToJSONTyped;
const OrientationOpportunityViewDto_1 = require("./OrientationOpportunityViewDto");
/**
 * Check if a given object implements the OrientationOpportunityViewsByProfileDto interface.
 */
function instanceOfOrientationOpportunityViewsByProfileDto(value) {
    if (!('profileId' in value) || value['profileId'] === undefined)
        return false;
    if (!('views' in value) || value['views'] === undefined)
        return false;
    return true;
}
function OrientationOpportunityViewsByProfileDtoFromJSON(json) {
    return OrientationOpportunityViewsByProfileDtoFromJSONTyped(json, false);
}
function OrientationOpportunityViewsByProfileDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'profileId': json['profileId'],
        'views': (json['views'].map(OrientationOpportunityViewDto_1.OrientationOpportunityViewDtoFromJSON)),
    };
}
function OrientationOpportunityViewsByProfileDtoToJSON(json) {
    return OrientationOpportunityViewsByProfileDtoToJSONTyped(json, false);
}
function OrientationOpportunityViewsByProfileDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'profileId': value['profileId'],
        'views': (value['views'].map(OrientationOpportunityViewDto_1.OrientationOpportunityViewDtoToJSON)),
    };
}
//# sourceMappingURL=OrientationOpportunityViewsByProfileDto.js.map